"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";

export function MattersCard({
  iconImage = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656bfa5eeb3430d878b88ea5_Vectors-Wrapper.svg",
  text = "We Care Deeply",
}) {
  return (
    <Block className={"matters_card"} tag={"div"}>
      <Block className={"maters_icon"} tag={"div"}>
        <Image
          alt={""}
          className={"icon-1x1-large"}
          height={"20"}
          loading={"lazy"}
          src={iconImage}
          width={"22"}
        />
      </Block>
      <Block className={"text-size-medium"} tag={"div"}>
        {text}
      </Block>
    </Block>
  );
}
